import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { EmptyState } from "@/components/Bits";

export const InclusionChips = ({ totals, testPrefix, empty = "Nothing counted yet" }) => {
  const entries = Object.entries(totals || {});
  if (!entries.length) return <span data-testid={`${testPrefix}-empty`} className="text-xs text-zinc-500">{empty}</span>;
  return (
    <div className="flex flex-wrap gap-1.5">
      {entries.map(([label, n]) => (
        <span key={label} data-testid={`${testPrefix}-${label.toLowerCase().replace(/\s+/g, "-")}`} className="rounded-lg border border-white/10 bg-zinc-800/70 px-2 py-0.5 text-xs">
          <span className="font-mono font-bold text-pink-200">{n}</span> <span className="text-zinc-300">{label}</span>
        </span>
      ))}
    </div>
  );
};

export default function InclusionsPage() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/inclusion-counts").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  return (
    <div className="rise">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight">Inclusions</h1>
      <p className="text-zinc-400 mt-2 text-sm md:text-base max-w-2xl">
        Still owed per joiner. Counted once a claim is covered by an approved payment, minus bundles already sent. Regular: 1 album + 2 photocards · Solo Digi: 1 + 1 · Unit Digi: 1 + 1 · Poca: 1 album + 4 photocards.
      </p>
      <div className="mt-8 space-y-2.5" data-testid="inclusions-joiner-list">
        {rows === null && <div className="text-zinc-500 text-sm">Loading…</div>}
        {rows?.length === 0 && <EmptyState title="No claims yet" hint="Joiners show up here once they have active claims." />}
        {rows?.map((r) => (
          <Link
            key={r.joiner_id}
            to={`/inclusions/${r.joiner_id}`}
            data-testid={`inclusion-joiner-${r.joiner_id}`}
            className="group flex items-center gap-4 rounded-2xl border border-white/5 bg-zinc-900/60 px-4 py-3.5 transition-colors duration-200 hover:border-pink-500/40 hover:bg-zinc-900"
          >
            <div className="min-w-0 flex-1 space-y-1.5">
              <div className="font-semibold truncate">{r.joiner_name}</div>
              <InclusionChips totals={r.owed} testPrefix={`inclusion-total-${r.joiner_id}`} empty={Object.keys(r.totals).length ? "All sent" : "Nothing counted yet"} />
            </div>
            <span className="font-mono text-xs text-zinc-400 whitespace-nowrap">{r.counted_claims}/{r.active_claims} paid</span>
            <ChevronRight className="h-4 w-4 text-zinc-600 transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </div>
  );
}
